const TrackingPlatform = {

    IOS_WEBVIEW:"IOS_WEBVIEW",
    ANDROID_WEBVIEW:"ANDROID_WEBVIEW",
    IOS_MSITE:"IOS_MSITE",
    ANDROID_MSITE:"ANDROID_MSITE",
    WEB:"WEB",
    OTHER_MSITE:"OTHER_MSITE"
}
export default TrackingPlatform


// WEBPACK FOOTER //
// ./src/enums/TrackingPlatform.js